'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaRecoverAccountController = function () {
  function WinresOmalomaRecoverAccountController($scope, $rootScope, omalomaService) {
    _classCallCheck(this, WinresOmalomaRecoverAccountController);

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.omalomaService = omalomaService;

    // Current status. Possible values:
    // init - Initializing.
    // enter_token - Ask for token sent to email.
    // recovering_account - Recovering account with token.
    // done - Account recovered. Trigger onDone.
    this.setStatus('init', null);

    // An error to be displayed. Passed to i18next.
    // Example error: Recovery rejected, check email and token.
    this.$scope.error = null;

    this.email = this.defaultEmail || "";
    this.token = this.defaultToken || "";
    this.newPassword = "";
  }

  _createClass(WinresOmalomaRecoverAccountController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.setStatus('enter_token', null);
      this.$scope.$on('login', function () {
        return _this.setStatus('enter_token', null);
      });
    }
  }, {
    key: 'setStatus',
    value: function setStatus(status, error) {
      this.$scope.status = status;
      console.log('[WORA] Set status to', status);
      if (error !== undefined) {
        if (error) console.log('[WORA] Error:', error);
        this.$scope.error = error;
      }
    }
  }, {
    key: 'recover',
    value: function recover(email, token, newPassword) {
      var _this2 = this;

      this.setStatus('recovering_account', null);
      var q = this.omalomaService.recoverAccount(this.connectionName, email, token, newPassword);
      q.then(function (response) {
        if (!response) {
          _this2.setStatus('enter_token', 'malfunction');
        } else if (response.Result === 'Success') {
          _this2.setStatus('done', null);
          _this2.onDone({ email: email, newPassword: newPassword });
          _this2.$rootScope.$broadcast('account-recover-done', email, newPassword);
        } else if (response.Result === 'Rejected') {
          _this2.setStatus('enter_token', 'rejected');
        } else {
          console.error('[WORA] Recovery failed:', response.Result, response.Message);
          _this2.setStatus('enter_token', 'malfunction');
        }
      }, function (error) {
        console.error('[WORA] Recovery error:', error);
        _this2.setStatus('enter_token', 'malfunction');
      });
    }
  }]);

  return WinresOmalomaRecoverAccountController;
}();

WinresOmalomaRecoverAccountController.$inject = ['$scope', '$rootScope', 'omalomaService'];

_module3.default.component('winresOmalomaRecoverAccount', {
  template: require('./winresOmalomaRecoverAccount.html'),
  controller: WinresOmalomaRecoverAccountController,
  require: {},
  bindings: {
    connectionName: '@',
    defaultEmail: '@',
    defaultToken: '@',
    onDone: '&'
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaRecoverAccount/winresOmalomaRecoverAccount.js
// module id = 359
// module chunks = 2